/*
    博客详情页活动广告位配置项
    adBanner: {
            link: 活动页地址,
            thumbnail: 缩略图地址
        }
*/
export const adBanner: { link: string; thumbnail: string; title: string; text: string } = {
  link: 'https://serverlesscloud.cn/blog/2020-12-29-webinar-meetup',
  thumbnail: 'https://img.serverlesscloud.cn/2020720/1595233528915-1588164013282-banner_hours%20%281%29.jpg',
  title: 'Tencent Serverless Hours | 第 13 期',
  text: '腾讯云 Serverless 云函数支持在线调试功能',
}
